"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPasswordStrength = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var zxcvbn_1 = __importDefault(require("zxcvbn"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var InfoTwoTone_1 = __importDefault(require("@material-ui/icons/InfoTwoTone"));
var core_1 = require("@material-ui/core");
var getPasswordStrength = function (password) {
    if (password === "") {
        return { score: 0, label: "default", class: "default-score" };
    }
    var testedResult = zxcvbn_1.default(password);
    var rules = 0;
    if (/[A-Z]/.test(password) &&
        /[a-z]/.test(password) &&
        /[0-9]/.test(password) &&
        /[!"£$%^&*()@~']/.test(password) &&
        /.{8}/.test(password)) {
        rules = 100;
    }
    else {
        if (/[A-Z]/.test(password))
            rules += 10;
        if (/[a-z]/.test(password))
            rules += 10;
        if (/[0-9]/.test(password))
            rules += 10;
        if (/[!"£$%^&*()@~#?]/.test(password))
            rules += 10;
        if (/.{8}/.test(password))
            rules += 10;
    }
    var finalScore = ((testedResult.score + 1) * rules) / 5;
    switch (true) {
        case finalScore > 75:
            return {
                score: finalScore,
                label: "Excellent",
                class: "excellent-score",
                rulesMet: rules === 100
            };
        case finalScore > 50:
            return {
                score: finalScore,
                label: "Good",
                class: "good-score",
                rulesMet: rules === 100
            };
        case finalScore > 25:
            return {
                score: finalScore,
                label: "Fair",
                class: "fair-score",
                rulesMet: rules === 100
            };
        default:
            return {
                score: finalScore,
                label: "Weak",
                class: "weak-score",
                rulesMet: rules === 100
            };
    }
};
exports.getPasswordStrength = getPasswordStrength;
var PasswordStrengthMeter = function (props) {
    var password = props.password, classes = props.classes;
    var passStrngth = exports.getPasswordStrength(password);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.LinearProgress, { variant: "determinate", value: passStrngth.score, classes: {
                determinate: "psm-backgroundBar",
                bar1Determinate: "psm-" + passStrngth.class
            } }),
        react_1.default.createElement(Typography_1.default, { variant: "subtitle1" },
            react_1.default.createElement("label", { className: "password-strength-meter-label " + (classes ? classes.label || "" : "") }, password && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Tooltip_1.default, { placement: "right-start", title: react_1.default.createElement(Typography_1.default, { variant: "caption", align: "left" },
                        "Your password must: ",
                        react_1.default.createElement("br", null),
                        "\u00B7 Be at least 8 characters long ",
                        react_1.default.createElement("br", null),
                        "\u00B7 Have at least one lower case letter ",
                        react_1.default.createElement("br", null),
                        "\u00B7 Have at least one upper case letter ",
                        react_1.default.createElement("br", null),
                        "\u00B7 Have at least one number ",
                        react_1.default.createElement("br", null),
                        "\u00B7 Contain at least one symbol") },
                    react_1.default.createElement(InfoTwoTone_1.default, { fontSize: "small", style: { marginBottom: "-5px" } })),
                react_1.default.createElement("strong", null, "Password strength: "), "" + passStrngth.label))))));
};
exports.default = PasswordStrengthMeter;
PasswordStrengthMeter.propTypes = {
    password: prop_types_1.default.string,
    className: prop_types_1.default.object,
    classes: prop_types_1.default.object,
    style: prop_types_1.default.object,
    id: prop_types_1.default.object
};
